/** True when the page runs inside any frame. An access error counts as framed. */
export function isFramed(win: Window = window): boolean {
  try {
    return win.self !== win.top;
  } catch {
    return true;
  }
}
